import axios from "axios"

const BASE_URL = "https://remittance-be.onrender.com/"

const apiGetMethod = async (route, params, headers) => {

    try {
        const response = await axios.get(BASE_URL + route, { headers, params })
        return response.data;
    } catch (error) {
        console.log(error);
    }
}

export default apiGetMethod;